// Hardcoded cohort capacity. Update these in this file each cycle.
const COHORTS = [
  { city: 'London', flavour: 'Hospital + hospice', start: '14 Jul', end: '18 Jul', capacity: 12, taken: 8 },
  { city: 'London', flavour: 'Hospital + hospice', start: '4 Aug', end: '8 Aug', capacity: 12, taken: 3 },
  { city: 'Birmingham', flavour: 'GP shadowing', start: '21 Jul', end: '25 Jul', capacity: 12, taken: 5 },
  { city: 'Manchester', flavour: 'GP shadowing', start: '28 Jul', end: '1 Aug', capacity: 12, taken: 7 },
];

export default function CohortWidget() {
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #ece8f6',
        borderRadius: 14,
        padding: '20px 22px',
        boxShadow: '0 8px 24px rgba(20, 5, 60, 0.05)',
        marginBottom: 22,
      }}
    >
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: '#5b21b6',
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          marginBottom: 8,
        }}
      >
        Live capacity
      </div>
      <h2 style={{ margin: '0 0 14px', fontSize: 20, color: '#1f1240' }}>
        Next Career Camp cohorts
      </h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
        {COHORTS.map((c, i) => {
          const left = c.capacity - c.taken;
          const tight = left <= 4;
          const full = left <= 0;
          return (
            <div
              key={i}
              style={{
                border: '1px solid #ece8f6',
                borderRadius: 12,
                padding: '14px 16px',
                background: full ? '#f4f4f5' : '#fafafa',
                opacity: full ? 0.55 : 1,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 6 }}>
                <strong style={{ fontSize: 15, color: '#1f1240' }}>{c.city}</strong>
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    padding: '2px 8px',
                    borderRadius: 999,
                    background: full ? '#fee2e2' : tight ? '#fef3c7' : '#dcfce7',
                    color: full ? '#991b1b' : tight ? '#92400e' : '#166534',
                  }}
                >
                  {full ? 'Full' : tight ? 'Almost full' : 'Spots open'}
                </span>
              </div>
              <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 6 }}>{c.flavour}</div>
              <div style={{ fontWeight: 700, fontSize: 14.5, color: '#1f1240', marginBottom: 8 }}>
                {c.start} – {c.end}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div style={{ flex: 1, height: 6, background: '#ece8f6', borderRadius: 999, overflow: 'hidden' }}>
                  <div
                    style={{
                      width: `${Math.min(100, (c.taken / c.capacity) * 100)}%`,
                      height: '100%',
                      background: full ? '#dc2626' : tight ? '#d97706' : '#7c3aed',
                    }}
                  />
                </div>
                <span style={{ fontSize: 12, color: '#6b7280', fontVariantNumeric: 'tabular-nums' }}>
                  {full ? '0' : left} of {c.capacity} left
                </span>
              </div>
            </div>
          );
        })}
      </div>
      <p style={{ margin: '14px 0 0', fontSize: 12.5, color: '#6b7280' }}>
        Capacity updates weekly. Hold a spot via the free 15-minute advisor call.
      </p>
    </div>
  );
}
